import { baseUrls, apiUrls } from "../../../utils/Endpoints.config";
import { getAxiosConfig, getFomatedError, setFormatedResponse } from "../services/apiService";

/* Add Department Service */
const selfAttendance = (params) => {
  const { axiosInstance, config } = getAxiosConfig();
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.attendance.selfAttendance}`,
    method: "GET",
    params: params,
    headers: config.headers || null,
    mode: "no-cors",
  })
    .then((res) => {
      return setFormatedResponse(res);
    })
    .catch((error) => {
      return getFomatedError(error);
    });
  return response;
};

/* Get Department Service */
const myTeamAttendance = (params) => {
  const { axiosInstance, config, source } = getAxiosConfig();
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.attendance.myTeamAttendance}`,
    method: "GET",
    params: params,
    headers: config.headers || null,
    mode: "no-cors",
  })
    .then((res) => {
      return setFormatedResponse(res);
    })
    .catch((error) => {
      return getFomatedError(error);
    });
  return response;
};

/* Get Department List Service*/
const allTeamAttendance = (params) => {
  const { axiosInstance, config, } = getAxiosConfig();
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.attendance.allTeamAttendance}`,
    method: "GET",
    params: params,
    headers: config.headers || null,
    mode: "no-cors",
  })
    .then((res) => {
      return setFormatedResponse(res);
    })
    .catch((error) => {
      return getFomatedError(error);
    });
  return response;
};

/* Attendance Report Service*/
const attendanceReport = (params) => {
  const { axiosInstance, config, } = getAxiosConfig();
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.attendance.attendanceReport}`,
    method: "POST",
    data: params,
    headers: config.headers || null,
    mode: "no-cors",
  })
    .then((res) => {
      return setFormatedResponse(res);
    })
    .catch((error) => {
      return getFomatedError(error);
    });
  return response;
};


/* Attendance Report Service*/
const getDepartmentWiseAttendance = (params) => {
  const { axiosInstance, config, } = getAxiosConfig();
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.attendance.getDepartmentWiseAttendance}`,
    method: "GET",
    params: params,
    headers: config.headers || null,
    mode: "no-cors",
  })
    .then((res) => {
      return setFormatedResponse(res);
    })
    .catch((error) => {
      return getFomatedError(error);
    });
  return response;
};



/* Attendance Report Service*/
const getAllEmployeeAttendance = (params) => {
  const { axiosInstance, config, } = getAxiosConfig();
  const response = axiosInstance({
    url: `${baseUrls.main}/${apiUrls.attendance.getAllEmployeeAttendance}`,
    method: "GET",
    params: params,
    headers: config.headers || null,
    mode: "no-cors",
  })
    .then((res) => {
      return setFormatedResponse(res);
    })
    .catch((error) => {
      return getFomatedError(error);
    });
  return response;
};


export default {
  selfAttendance,
  myTeamAttendance,
  allTeamAttendance,
  attendanceReport,
  getDepartmentWiseAttendance,
  getAllEmployeeAttendance
}